module.exports = __webpack_public_path__ + "static/media/flip-card.ea7b1558.wav";